import { CompanyRequestDto } from "model/Company";

export type CreateCompanyRegistrationRequestParams = {
  readonly city: string;
  readonly companyAdress: string;
  readonly companyName: string;
  readonly contactPersonApiPhoneNumber: string;
  readonly contactPersonEmail: string;
  readonly firebaseEmail?: string;
  readonly firstName: string;
  readonly lastName: string;
  readonly legalName: string;
  readonly location: string;
  readonly postalCode: string;
  readonly registrationNumber: string;
};

/**
 * Creates the company registration request payload from the collected form
 * values. The contact phone number arrives already in the form the API stores,
 * because converting it is the one step that can fail and the caller answers
 * for that.
 */
export function createCompanyRegistrationRequest({
  city,
  companyAdress,
  companyName,
  contactPersonApiPhoneNumber,
  contactPersonEmail,
  firebaseEmail,
  firstName,
  lastName,
  legalName,
  location,
  postalCode,
  registrationNumber,
}: CreateCompanyRegistrationRequestParams): CompanyRequestDto {
  return {
    address: companyAdress.trim(),
    city: city.trim(),
    collectiveAgreement: null,
    companyName: companyName.trim(),
    contactPerson: `${firstName.trim()} ${lastName.trim()}`,
    countryId: 1,
    description: "",
    email: firebaseEmail?.trim() || contactPersonEmail.trim(),
    error: null,
    firstName: firstName.trim(),
    lastName: lastName.trim(),
    legalName: legalName.trim(),
    location,
    phoneNumber: contactPersonApiPhoneNumber,
    postalCode: postalCode.trim(),
    registrationNumber: registrationNumber.replace(/\D/g, ""),
    websiteUrl: "",
  };
}
